exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".main-image .image-tip[data-v-1daf42ad]{margin-bottom:15px}.main-image .image-tip .spec-tip[data-v-1daf42ad]{margin-top:8px}.main-image .image-upload-tip[data-v-1daf42ad]{margin-top:8px;padding:4px 10px}.main-image .image-upload-tip[data-v-1daf42ad]  .el-alert__icon{font-size:14px;width:14px}.main-image .image-upload-tip[data-v-1daf42ad]  .el-alert__title{font-size:12px;line-height:1.4}.main-image .cameraIconfont[data-v-1daf42ad]{margin:auto;font-size:2.5em;cursor:pointer}", ""]);

// exports
